import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, cn } from "../../../design-system/index.js";

const MOCK_SECTION = {
  heading: "Conteudo provisório",
  text: "Estamos finalizando este documento legal. Em breve, todas as clausulas oficiais estarao disponiveis nesta pagina.",
};

export default function LegalDocumentPage({ title, date, sections, accent = "rose" }) {
  const navigate = useNavigate();

  const colorClass = useMemo(() => {
    if (accent === "slate") return "text-slate-blue-400";
    return "text-rose-400";
  }, [accent]);

  const safeSections = Array.isArray(sections) && sections.length > 0 ? sections : [MOCK_SECTION];

  return (
    <div className="min-h-screen bg-warm-50 pt-28 pb-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6">
        <div className="mb-8 rounded-3xl border border-warm-100 bg-white p-6 shadow-sm sm:p-8">
          <p className={cn("mb-2 text-xs font-semibold uppercase tracking-[0.14em]", colorClass)}>
            Documento legal
          </p>
          <h1 className="font-heading text-3xl font-bold leading-tight text-warm-900 sm:text-4xl">
            {title}
          </h1>
          {date && <p className="mt-3 text-sm text-warm-500">{date}</p>}
        </div>

        <div className="space-y-5">
          {safeSections.map((section, sectionIndex) => (
            <section
              key={`${section.heading || "secao"}-${sectionIndex}`}
              className="rounded-2xl border border-warm-100 bg-white p-5 shadow-sm sm:p-6"
            >
              {section.heading && (
                <h2 className="mb-3 font-heading text-xl font-bold text-warm-900">
                  {section.heading}
                </h2>
              )}

              {section.text && (
                <p className="mb-4 whitespace-pre-line text-[15px] leading-relaxed text-warm-700">
                  {section.text}
                </p>
              )}

              {Array.isArray(section.subsections) && section.subsections.length > 0 && (
                <div className="space-y-3">
                  {section.subsections.map((sub, subIndex) => (
                    <article
                      key={`${sub.subheading || "subsecao"}-${subIndex}`}
                      className="rounded-xl bg-warm-50 p-4"
                    >
                      {sub.subheading && (
                        <h3 className="mb-1 text-sm font-semibold text-warm-900 sm:text-base">
                          {sub.subheading}
                        </h3>
                      )}
                      {sub.subtext && (
                        <p className="text-sm leading-relaxed text-warm-700 sm:text-[15px]">
                          {sub.subtext}
                        </p>
                      )}
                      {Array.isArray(sub.list) && sub.list.length > 0 && (
                        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-warm-700 sm:text-[15px]">
                          {sub.list.map((item, itemIndex) => (
                            <li key={`item-${itemIndex}`}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </article>
                  ))}
                </div>
              )}

              {Array.isArray(section.list) && section.list.length > 0 && (
                <ul className="list-disc space-y-1 pl-5 text-sm leading-relaxed text-warm-700 sm:text-[15px]">
                  {section.list.map((item, itemIndex) => (
                    <li key={`list-${itemIndex}`}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button className="rounded-full px-6" onClick={() => navigate("/auth")}>Voltar ao cadastro</Button>
          <Button variant="outline" className="rounded-full px-6" onClick={() => navigate("/")}>Voltar para inicio</Button>
        </div>
      </div>
    </div>
  );
}